import * as types from './actionTypes';
import {startAjaxCall, startAjaxCallError} from './ajaxStatusActions';
import caseDataApi from '../api/forms/caseDataApi';
import {COMBINED_SUBMISSION_NOT_SUBMITTED} from '../constants/EstablishmentStatusEnumeration';

export function createCaseDataSuccess(caseData) {
  return {type: types.CREATE_CASE_DATA_SUCCESS, caseData};
}

export function loadCaseDataSuccess(caseData) {
  return {type: types.LOAD_CASE_DATA_SUCCESS, caseData};
}

export function loadAllCaseDataSuccess(caseDatas) {
  return {type: types.LOAD_ALL_CASE_DATA_SUCCESS, caseDatas};
}

export function updateEstablishmentStatus(establishments) {
  return {type: types.EDIT_ESTABLISHMENT_SUCCESS, establishments};
}

export function clearCaseDataPageFilter() {
  return { type: types.CLEAR_CASE_DATA_PAGE_FILTER };
}

export function submitCaseDataSummary(establishment, caseData, formId) {
  const submitFunction = formId ? caseDataApi.editCaseData :
    caseDataApi.createCaseData;
  return function(dispatch) {
    dispatch(startAjaxCall());
    return submitFunction(caseData, formId)
      .then(returnedCaseData => {
        dispatch(createCaseDataSuccess(returnedCaseData.results[0]));
        dispatch(updateEstablishmentStatus(Object.assign({}, establishment, {total_submitted_cases: establishment.total_submitted_cases + 1, combined_submission_status: COMBINED_SUBMISSION_NOT_SUBMITTED})));
        if (establishment) {
          return establishment.id;
        } else {
          return null;
        }
      }).catch(error => {
        startAjaxCallError(error);
        throw error;
      });
  };
}

export function loadCaseData(link) {
  return function(dispatch) {
    dispatch(startAjaxCall());
    return caseDataApi
      .getCaseData(link)
      .then(returnedCaseData => {
        dispatch(loadCaseDataSuccess(returnedCaseData.results[0]));
        return returnedCaseData.results[0];
      }).catch(error => {
        startAjaxCallError(error);
        throw error;
      });
  };
}

export function loadAllCaseData(establishmentId) {
  return function(dispatch) {
    dispatch(startAjaxCall());
    return caseDataApi
      .getAllCaseData(establishmentId)
      .then(returnedCaseDataList => {
        if (returnedCaseDataList != null) {
          dispatch(loadAllCaseDataSuccess(returnedCaseDataList.results));
          return returnedCaseDataList;
        }
        else {
          return [];
        }
      }).catch(error => {
        startAjaxCallError(error);
        throw error;
      });
  };
}


/** WEBPACK FOOTER **
 ** ./src/actions/caseDataActions.js
 **/